import { useState, useEffect } from "react";
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

// undefined = session check in progress, null = signed out, object = signed in
export function useAuth(){
  const [user,setUser]=useState(undefined);
  const [loginEmail,setLoginEmail]=useState("");
  const [loginPassword,setLoginPassword]=useState("");
  const [loginError,setLoginError]=useState("");
  const [loginLoading,setLoginLoading]=useState(false);

  useEffect(()=>{
    const unsub=onAuthStateChanged(auth,u=>setUser(u??null));
    return unsub;
  },[]);

  const handleLogin=async()=>{
    if(!loginEmail||!loginPassword)return;
    setLoginLoading(true);setLoginError("");
    try{
      await signInWithEmailAndPassword(auth,loginEmail,loginPassword);
    }catch(e){
      setLoginError(
        e.code==="auth/invalid-credential"||e.code==="auth/user-not-found"||e.code==="auth/wrong-password"
          ?"Incorrect email or password."
          :"Sign-in failed. Please try again."
      );
      setLoginLoading(false);
    }
  };

  const logout=()=>signOut(auth);

  return {
    user,
    loginEmail,setLoginEmail,
    loginPassword,setLoginPassword,
    loginError,setLoginError,
    loginLoading,
    handleLogin,
    logout,
  };
}
